export const routeData = [
  {
    id: 101,
    name: '首页',
    path: '/home'
  },
  {
    id: 200,
    name: '医院概况',
    path: '/hospital-intro',
    children: [
      {
        id: 21,
        name: '医院简介',
        path: '/hospital-intro'
      },
      {
        id: 22,
        name: '医院领导',
        path: '/hospital-intro'
      },
      {
        id: 23,
        name: '院容院貌',
        path: '/hospital-intro'
      },
      {
        id: 24,
        name: '医院荣誉',
        path: '/hospital-intro'
      },
      {
        id: 25,
        name: '科室导览',
        path: '/hospital-intro'
      },
      {
        id: 26,
        name: '医疗设备',
        path: '/hospital-intro'
      }
    ]
  },
  {
    id: 201,
    name: '就医指南',
    path: '/medical-guide',
    children: [
      {
        id: 31,
        name: '预约挂号',
        path: '/medical-guide'
      },
      {
        id: 32,
        name: '门诊排班',
        path: '/medical-guide'
      },
      {
        id: 33,
        name: '就诊流程',
        path: '/medical-guide'
      },
      {
        id: 34,
        name: '医师风采',
        path: '/medical-guide'
      },
      {
        id: 35,
        name: '院内导航',
        path: '/medical-guide'
      },
      {
        id: 36,
        name: '来院路线',
        path: '/medical-guide'
      },
    ]
  },
  {
    id: 202,
    name: '党群建设',
    path: '/party-building',
    children: [
      {
        id: 41,
        name: '党建园地',
        path: '/party-building'
      },
      {
        id: 42,
        name: '团员青年',
        path: '/party-building'
      },
      {
        id: 43,
        name: '双拥专栏',
        path: '/party-building'
      },
    ]
  },
  {
    id: 203,
    name: '新闻中心',
    path: '/news',
    children: [
      {
        id: 51,
        name: '医院动态',
        path: '/news'
      },

      {
        id: 52,
        name: '媒体聚焦',
        path: '/news'
      },
      {
        id: 53,
        name: '视频中心',
        path: '/news'
      }

    ]
  },
  {
    id: 204,
    name: '通知公告',
    path: '/notices',
    children: [
      {
        id: 61,
        name: '招标采购',
        path: '/notices'
      },
      {
        id: 62,
        name: '医院公告',
        path: '/notices'
      },
      {
        id: 63,
        name: '院务公开',
        path: '/notices'
      },
      {
        id: 64,
        name: '院长信箱',
        path: '/notices'
      },

    ]
  },
  {
    id: 205,
    name: '专题专栏',
    path: '/special-topics',
    children: [
      {
        id: 71,
        name: '科研教学',
        path: '/special-topics'
      },
      {
        id: 72,
        name: '医疗/护理天地',
        path: '/special-topics'
      },
      {
        id: 73,
        name: '健康促进',
        path: '/special-topics'
      },
      {
        id: 74,
        name: '文化建设',
        path: '/special-topics'
      },
      {
        id: 75,
        name: '他山之石/人文',
        path: '/special-topics'
      },
      {
        id: 76,
        name: '文明创建',
        path: '/special-topics'
      },
      {
        id: 77,
        name: '安全生产',
        path: '/special-topics'
      },
      {
        id: 78,
        name: '保密宣传教育',
        path: '/special-topics'
      },
    ]
  },
  {
    id: 206,
    name: '信息公开',
    path: '/info-disclosure',
    children: [
      {
        id: 81,
        name: '服务时间',
        path: '/info-disclosure'
      },
      {
        id: 82,
        name: '专业介绍',
        path: '/info-disclosure'
      },
      {
        id: 83,
        name: '预约诊疗',
        path: '/info-disclosure'
      },
      {
        id: 84,
        name: '医保服务',
        path: '/info-disclosure'
      },
      {
        id: 85,
        name: '就诊须知',
        path: '/info-disclosure'
      },
      {
        id: 86,
        name: '住院须知',
        path: '/info-disclosure'
      },
      {
        id: 87,
        name: '交通导引',
        path: '/info-disclosure'
      },
      {
        id: 88,
        name: '咨询服务',
        path: '/info-disclosure'
      },
      {
        id: 89,
        name: '机构人员',
        path: '/info-disclosure'
      },
      {
        id: 810,
        name: '设备技术',
        path: '/info-disclosure'
      },
      {
        id: 811,
        name: '研究平台',
        path: '/info-disclosure'
      },
      {
        id: 812,
        name: '医疗价格',
        path: '/info-disclosure'
      },
      {
        id: 813,
        name: '环境导引',
        path: '/info-disclosure'
      },
      {
        id: 814,
        name: '诊疗服务',
        path: '/info-disclosure'
      },
      {
        id: 815,
        name: '行风投诉',
        path: '/info-disclosure'
      },
      {
        id: 816,
        name: '科普健教',
        path: '/info-disclosure'
      },
      {
        id: 817,
        name: '便民服务',
        path: '/info-disclosure'
      },
      {
        id: 818,
        name: '监督保障',
        path: '/info-disclosure'
      },
      {
        id: 819,
        name: '院务公开',
        path: '/info-disclosure'
      },
    ]
  }
]
